// extracted by mini-css-extract-plugin
export default {"navbar":"page-search_navbar__I7k5j","search":"page-search_search__gutMe"};